import React from 'react';
import { Tag } from 'antd';
import { DATA_SENSITIVITY_COLORS, DataSensitivityLevelId } from '@sonar-software/sonar-core';
export const DataSensitivityLevelTag = ({ dataSensitivityLevelId }) => {
    if (dataSensitivityLevelId === undefined) {
        return null;
    }
    const label = DataSensitivityLevelId[dataSensitivityLevelId];
    const dataSensitivityTagColor = DATA_SENSITIVITY_COLORS[dataSensitivityLevelId];
    return dataSensitivityLevelId === DataSensitivityLevelId.None ?
        label : React.createElement(Tag, { color: dataSensitivityTagColor }, label);
};
